import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/API/api.service';
import * as $ from 'jquery';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavbarStyleOneComponent } from '../../common/navbar-style-one/navbar-style-one.component';

@Component({
  selector: 'app-sub-category',
  templateUrl: './sub-category.component.html',
  styleUrl: './sub-category.component.scss'
})
export class SubCategoryComponent implements OnInit, AfterViewInit {

  subCategoryID: any
  subCategoryName =''
  subCategories: any
  vendorInfo: any
  subCategoriesLength: number
  categoryImage = ''
  selectedVendor: any
  errorMsg: string = ''
  showError: boolean = false

  constructor(private url: ActivatedRoute,private router: Router,private api: ApiService,private encrypt: EncryptionService,private formBuilder: FormBuilder) {
  }

  vendorId: any
  currentStatus: any
  ngOnInit(): void {
    // this.categoryImage = sessionStorage.getItem('categoryImage')
    if(this.url.snapshot.params['subCatID']){
      this.subCategoryID = this.url.snapshot.params['subCatID'];
      this.subCategoryID = this.decodeHash(this.subCategoryID)
      this.subCategoryName = this.url.snapshot.params['subCatName']
      console.log(this.subCategoryID)
      localStorage.setItem('VendorID',this.subCategoryID)
      this.vendorId = localStorage.getItem('VendorID')
    }
    this.quantityCounter = 0
    const quan = localStorage.getItem('quantity')
    if(parseInt(quan) > 0){
      this.quantityCounter = parseInt(quan)
    }

    if(this.subCategoryID){
      this.api.allVendorSubCategory(this.subCategoryID,1).subscribe({
        next: (response: any) => {
          this.subCategories = response.data.data
          // console.log(this.subCategories)
          this.subCategoriesLength = this.subCategories.length
          if(this.subCategoriesLength > 0){
            this.vendorInfo = this.subCategories[0].vendor_info
            // console.log(this.vendorInfo)
            localStorage.setItem('deliveryCost',this.vendorInfo.delivery_cost)
          }
          this.subCategories.map((subCategory: any) => {
            subCategory.hashedId = this.generateHash(subCategory.id.toString());
          });
          this.getProducts(this.subCategories[0].id)
          // console.log(this.subCategories)
        }, error: (error: HttpErrorResponse) => {
          console.error(error);
        }
      })

      this.api.selectedVendor(this.subCategoryID,1).subscribe({
        next: (response: any) => {
          this.selectedVendor = response.data.selectedVendor
          this.categoryImage = response.data.selectedVendor.avatar
          if(this.selectedVendor.current_status.is_open == false){
            this.currentStatus = "مغلق"
            this.showError = true
            this.errorMsg = this.selectedVendor.current_status.next_opening
            setTimeout(() => {
              this.showError = false
              this.errorMsg = ''
            }, 3000);
          }else{
            if(this.selectedVendor.status == 'closed'){
              this.currentStatus = "مغلق"
              this.showError = true
              this.errorMsg = this.selectedVendor.status_hint == '' ? "" : "المطعم مغلق حاليا"
              setTimeout(() => {
                this.showError = false
                this.errorMsg = ''
              }, 3000);
            }else if(this.selectedVendor.status == 'busy'){
              this.currentStatus = "مشغول"
              this.showError = true
              this.errorMsg = this.selectedVendor.status_hint == '' ? "" : "المطعم مشغول حاليا"
              setTimeout(() => {
                this.showError = false
                this.errorMsg = ''
              }, 3000);
            }else{
              this.currentStatus = "مفتوح"
            }
          }
        }, error: (error: HttpErrorResponse) => {
          console.error(error);
        }
      })
    }

    this.isFav = false
    const token = localStorage.getItem('userToken')
    if(token){
      console.log('token')
      if(localStorage.getItem('oldVendorID') != this.vendorId){
        localStorage.setItem('oldVendorID',this.vendorId)
        this.emptyCart()
      }
      // this.api.getMyFav(1).subscribe({
      //   next: (response) => {
      //     // console.log(response.data.data)
      //     const fav = response.data.data.filter( (item: any) => item.id == this.subCategoryID)
      //     if(fav.length > 0){
      //       // console.log(fav)
      //       this.isFav = true
      //     }
      //   }, error: (error: HttpErrorResponse) => {
      //     console.log(error);
      //   }
      // })
    }

    
  }

  emptyCart(){
    this.api.emptyCart().subscribe({
      next: (response) => {
        this.navbarComponent.getCart()
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }
  searchedProducts: any[] = [];
  showResults = false;
  searchProducts(searchText: string) {
    console.log(searchText);
    if (searchText.length > 0) {
      this.api.vendorSearch(this.vendorId, searchText).subscribe({
        next: (response: any) => {
          this.searchedProducts = response.data.data;
          this.showResults = true;
        },
        error: (error: HttpErrorResponse) => {
          console.error(error);
          this.searchedProducts = [];
        }
      });
    } else {
      this.searchedProducts = [];
    }
  }

  selectProduct(product: any) {
    // Navigate to product page - adjust the route as needed
    // this.router.navigate(['/product', product.id]);
    this.productPage(this.subCategoryName,product.name_ar,product.id)
    this.showResults = false;
  }

  onSearchBlur() {
    // Small timeout to allow click on results before hiding
    setTimeout(() => {
      this.showResults = false;
    }, 200);
  }

  preventBlur(event: MouseEvent) {
    // Prevent input blur when clicking on results
    event.preventDefault();
  }

  ngAfterViewInit(): void {
    // $('.inner-bg3').css('background-image',`url(${this.categoryImage})`)
  }

  sendImage(image: string){
    sessionStorage.setItem('subImage',image)
  }

  decodeHash(hashedId: string): string | null {
    return this.encrypt.decryptionAES(hashedId);
  }

  generateHash(id: string): string {
    return this.encrypt.encryptionAES(id)
  }

  trackById(item: any): number {
    return item.id;
  }

  productLength: number
  products: any
  selectedSizes: { [key: number]: any } = {};
  getProducts(categoryId: number){
    // console.log(categoryId)
    this.api.allSubCategoryProducts(categoryId,1).subscribe({
      next: (response: any) => {
        this.products = response.data.data
        this.productLength = this.products.length
        this.products.forEach(product => {
          if (product.types.length > 0) {
              this.selectedSizes[product.id] = product.types[0]; // Select first size by default
          }
        });
        // console.log(this.products)
      },error: (error: HttpErrorResponse) => {
        console.error(error);
      }
    })
  }

  productQuantities: { [key: number]: number } = {}; // Store quantity per product
  quantity(productId: number, change: number) {
      if (!this.productQuantities[productId]) {
          this.productQuantities[productId] = 0; // Initialize if not set
      }
      this.productQuantities[productId] += change;
      // Ensure the quantity is not negative
      if (this.productQuantities[productId] < 0) {
          this.productQuantities[productId] = 0;
      }
  }

  // Calculate total quantity of all added products
  getTotalAddedQuantity(): number {
      return Object.values(this.productQuantities).reduce((total, qty) => total + qty, 0);
  }

  signInFirst: boolean = false;
  showSuccess: boolean = false;
  successMsg = ''
  @ViewChild(NavbarStyleOneComponent) navbarComponent: NavbarStyleOneComponent;
  sendCart() {
    if(this.currentStatus != 'مفتوح'){
      return;
    }
    const cartData = {
        products: Object.keys(this.productQuantities)
            .filter(productId => this.productQuantities[+productId] > 0) // Only include products with quantity > 0
            .map(productId => ({
                product_id: +productId,
                type: this.selectedSizes[+productId]?.id || null, // Get selected type
                quantity: this.productQuantities[+productId]
            }))
    };
    // console.log(cartData); // Debugging
    this.api.addToCart(cartData).subscribe({
        next: response => {
          if(response.success == true){
            this.showSuccess = true
            this.successMsg = "تمت اضافة المنتج بنجاح"
            this.navbarComponent.getCart()
            setTimeout(() => {
              this.showSuccess = false
              this.successMsg = ''
              window.location.href = '/cart'
            }, 2000);
          }
        },error: (error: HttpErrorResponse) => {
          if(error.error.message == "Sign in first"){
            this.signInFirst = true;
            $('#openModal').click();
          }
        }
    });
  }

  productPage(subCategoryName: string,productName: string,productId: number){
    window.location.href = `products-details/${subCategoryName}/${productName}/${productId}`
  }

  isFav: boolean = false;
  quantityCounter: any
  toggleFavourite(id: number){
    // $('.heart-btn .fa-haert').toggleClass('fa-regular')
    this.api.addToFav(id).subscribe({
      next: (response) => {
        // console.log(response)
        if(response.success == true){
          this.isFav = !this.isFav
        }
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }

}
